import React, { Component } from "react";
import { Accordion } from "./components/setting-accordion";
import { SaveButton } from "./components/save-button";
import Icon from "../../../../../../images/settings-icons/setting-protein.png";
import styled from "styled-components";
import { withStyles } from '@material-ui/core/styles';
import Slider from '@material-ui/core/Slider';
import { modifyUser } from "../../../../../../api";

const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const ProteinSlider = withStyles({
  root: {
    color: '#06cb40',
    height: 8,
  },
  thumb: {
    height: 32,
    width: 32,
    backgroundColor: '#dae3f1',
    border: '5px solid currentColor',
    marginTop: -13,
    marginLeft: -18,
    '&:focus, &:hover, &$active': {
      boxShadow: 'inherit',
    },
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 4px)',
  },
  track: {
    height: 8,
    borderRadius: 4,
  },
  rail: {
    color: '#b7c1d6',
    height: 8,
    borderRadius: 4,
  },
})(Slider);

class ProteinAdjustment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sliderValue: null,
      showRestriction: false,
      expanded: false,
      disableSubmit: true,
      isSubmitting: false,
      show: false,
    };
  }

  componentDidUpdate(prevProps) {
    const effectiveSliderValue = this.state.sliderValue === null ? this.props.extraProteinLevel : this.state.sliderValue;
    if (
      this.state.showRestriction &&
      effectiveSliderValue < this.props.highestProteinBoost
    ) {
      this.setState({ showRestriction: false });
    }
  }

  handlePanelChange = (event, expanded) => {
    let updates = { expanded: expanded };
    if (!expanded) {
      updates.showRestriction = false;
    }
    this.setState(updates);
  };

  handleChange = (name, val) => {
    if (
      name === "sliderValue" &&
      val > this.props.highestProteinBoost
    ) {
      val = this.props.highestProteinBoost;
      this.setState({ showRestriction: true });
    } else {
      let updates = {
        [name]: val,
        disableSubmit: Number(val) === this.props.extraProteinLevel,
      };
      if (
        name === "sliderValue" &&
        val < this.props.highestProteinBoost
      ) {
        updates.showRestriction = false;
      }
      this.setState(updates);
    }
  };

  handleSubmit = (event) => {
    let extraProteinLevel = this.state.sliderValue === null ? this.props.extraProteinLevel : this.state.sliderValue;
    if (extraProteinLevel < 0) {
      extraProteinLevel = extraProteinLevel * this.props.negativeFactor + 100;
      if (extraProteinLevel > 200) {
        extraProteinLevel = 200;
      }
    }
    this.setState({ isSubmitting: true });

    modifyUser(this.props.userId, this.props.portalId, {
      extra_protein_level: extraProteinLevel,
    }).then((res) => { 
      setTimeout(() => {
        this.setState({ disableSubmit: true, isSubmitting: false });
        this.props.openSnackbar('Setting has been updated', false);
        this.props.loadPortalAccount();
      }, 1000);
      console.log('successful update')
    }).catch((err) => {
      setTimeout(() => {
        this.setState({ isSubmitting: false });
        this.props.openSnackbar('Setting failed to update', true);
      }, 1000);
      console.log('failed update: ', err)
    });
  };

  render() {
    const effectiveSliderValue = this.state.sliderValue === null ? this.props.extraProteinLevel : this.state.sliderValue;
    const adjustment = effectiveSliderValue * 0.005 * this.props.weight;
    const desiredProtein = this.props.suggestedProtein + adjustment;
    const settingPreview = (adjustment >= 0 ? '+' : '') + adjustment.toFixed(1) + ' G';

    return (
      <Accordion
        show={this.state.show}
        setShow={(val) => this.setState({show: val})}  
        icon={Icon}
        settingName="Protein adjustment"
        currentSetting={settingPreview}
        description="Add or reduce protein"
        // alternateColor
      >
        <>
          <div>
            <p>
              Avatar sets your protein target at the optimal level based on your goal, lean body mass, activity level, age, and dietary restrictions. Additional protein won't help you preserve or build significantly more muscle, but it may help you better control hunger.
            </p>
            <div className="protein-adjustment-widget-target-display">
              <div className="protein-adjustment-widget-target-value">
                <h1>
                  {this.props.suggestedProtein.toFixed()}
                  g
                </h1>
                <h2>Suggested Protein Target</h2>
              </div>
              <div className="protein-adjustment-widget-target-value">
                <h1>{desiredProtein.toFixed()}g</h1>
                <h2>Desired Protein Target</h2>
              </div>
            </div>
            <div>
              <div style={{width: '100%', display: 'flex', justifyContent: 'space-between', marginTop: '32px'}}>
                <p id="preferences-slider-min">LOWER</p>
                <p id="preferences-slider-max">HIGHER</p>
              </div>
              <div style={{padding: '0 8px 0 8px'}}>
                <ProteinSlider 
                  min={this.props.lowestProteinLevel}
                  max={100}
                  value={effectiveSliderValue}
                  onChange={(e, val) => this.handleChange("sliderValue", val)}
                  name="sliderValue"
                  valueLabelDisplay='off'
                  aria-label='protein-slider'
                />
              </div>
            </div>
            {this.state.showRestriction && (
              <p style={{ marginBottom: "10px", fontWeight: "bold" }}>
                Your protein boost is currently restricted to keep your carbs from
                getting too low.
              </p>
            )}
          </div>
          <ButtonRow>
            <SaveButton
              disabled={this.state.disableSubmit}
              isLoading={this.state.isSubmitting}
              onClick={this.handleSubmit}
            />
          </ButtonRow>
        </>
      </Accordion>
    );
  }
}

export default ProteinAdjustment;
